import type {ReactElement} from 'react';
import {useContext} from 'react';
import {BrandAssetName} from '@Components/editor-brands/editor-brands.types';
import EditorBrands from '@Components/editor-brands';
import BrandColors from '@Components/editor-brands/components/brand-colors';
import {noop} from '@Utils/general.util';
import type {BrandsSectionProperties} from '@Components/editor-brands/editor-brands';
import type {RGBA} from '@Utils/color.util';
import {hexToRgba} from '@Utils/color.util';
import {trackHalloweenBrandKitUsageIfApplicable} from '@Libraries/brands-library';
import {getSwatchesLayout} from '@Components/color-picker-v2/components/swatches/swatches-library';
import {ColorPickerLayoutContext} from '@Components/color-picker-v2/color-picker-layout-context';

interface BrandsSectionProps extends BrandsSectionProperties {
  className?: string;
  showSmallDropdownHeader?: boolean;
  isMobileVersion?: boolean;

  onAddBrandAssetClicked(): void;

  onColorSelect(color: RGBA): void;
}

export function BrandsSection({
  removeDefaultPadding = false,
  dontOpenBrandsDropdown = false,
  onClickBrandsSelector = noop,
  showSmallDropdownHeader = false,
  isMobileVersion = false,
  ...props
}: BrandsSectionProps): ReactElement<any> | null {
  const colorPickerLayout = useContext(ColorPickerLayoutContext);
  return (
    <EditorBrands
      className={props.className}
      isSmallSection
      brandAsset={BrandAssetName.COLORS}
      onAddBrandAsset={(): void => {
        props.onAddBrandAssetClicked();
      }}
      dontOpenBrandsDropdown={dontOpenBrandsDropdown}
      removeDefaultPadding={removeDefaultPadding}
      onClickBrandsSelector={(): void => {
        onClickBrandsSelector();
      }}
      showSmallDropdownHeader={showSmallDropdownHeader}
    >
      <BrandColors
        layout={getSwatchesLayout(colorPickerLayout, isMobileVersion)}
        onAddColor={(color: string): void => {
          trackHalloweenBrandKitUsageIfApplicable();
          props.onColorSelect(hexToRgba(color));
        }}
      />
    </EditorBrands>
  );
}
